import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    EmailField,
} from 'react-admin';

const emailFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Email" source="email" name="email" />,
    <TextInput label="Company id" source="company.id" name="company.id" />,
];

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminEmailList = () => {
    return (
        <List
            actions={<ListActions/>}
            filters={ emailFilters }>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id"/>
                <EmailField source="email" />
                <TextField source="description" />
                <ReferenceField
                    source="company"
                    reference="companies"
                    link="edit"
                >
                    <TextField source="name"/>
                </ReferenceField>
                <>
                    <ShowButton/>
                    <EditButton/>
                </>
            </Datagrid>
        </List>
    );
}